import React from "react";
import { HiOutlineAcademicCap } from "react-icons/hi";
import SectionHeading from "./SectionHeading";
import { staggerContainer, staggerItem } from "./Reveal";
import { motion } from "framer-motion";
import { educationMeta } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function Education() {
    const { t } = useLanguage();

    return (
        <section id="education" className="section section--alt">
            <div className="section__inner">
                <SectionHeading eyebrow={t.education.eyebrow} title={t.education.title} />

                <motion.div
                    className="edu-grid"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.25 }}
                >
                    {educationMeta.map((item) => {
                        const text = t.education.items[item.id];
                        return (
                            <motion.div className="edu-card" key={item.id} variants={staggerItem} whileHover={{ y: -6 }}>
                                <span className="edu-card__icon">
                                    <HiOutlineAcademicCap />
                                </span>
                                <h3>{text.title}</h3>
                                <p className="edu-card__place">{text.place}</p>
                                <p className="edu-card__date">{item.date}</p>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
}
